module.exports = __webpack_public_path__ + "img/hic-stomach-cancer-male.15166934.png";